/** Maps BE `UserReferenceDto` / legacy wire shapes to a display label for snapshot saved-by metadata (TROC-206). */
export function resolveSavedByDisplay(o: Record<string, unknown>): string {
  const displayName = o.savedByDisplayName ?? o.SavedByDisplayName;
  if (typeof displayName === 'string' && displayName.trim() !== '') {
    return displayName.trim();
  }

  const flatUsername = String(o.savedByUserName ?? o.savedByUsername ?? o.SavedByUserName ?? o.SavedByUsername ?? '').trim();
  if (flatUsername !== '') return flatUsername;

  const ref = o.savedBy ?? o.SavedBy;
  if (ref !== null && typeof ref === 'object') {
    const r = ref as { username?: string; fullName?: string; Username?: string; FullName?: string };
    const fullName = (r.fullName ?? r.FullName ?? '').trim();
    const username = (r.username ?? r.Username ?? '').trim();
    if (fullName && username && fullName.toLowerCase() !== username.toLowerCase()) {
      return `${fullName} (${username})`;
    }
    return fullName || username || 'Unknown';
  }

  if (typeof ref === 'number') {
    if (ref === 0) return 'Unknown';
    return String(ref);
  }

  if (typeof ref === 'string' && ref.trim() !== '') {
    return ref.trim();
  }

  return 'Unknown';
}

/** Resolves snapshot save timestamp; does not fall back to `asOfDate` (TROC-206). */
export function resolveSavedAtIso(o: Record<string, unknown>): string {
  return String(o.utcSavedOn ?? o.UtcSavedOn ?? o.savedAt ?? o.SavedAt ?? '').trim();
}
